import React from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import { AuthenticatedTemplate, UnauthenticatedTemplate } from "@azure/msal-react";
import Login from "../../app/auth/Login";
import AdminMainLayout from "../../components/layout/AdminMainLayout";
import AIDashboardWorkbench from "../../components/dashboardBuilder/AIDashboardWorkbench";

const DrawerHeader = styled("div")(({ theme }) => ({
  ...theme.mixins.toolbar,
}));

const AIDashboardBuilderPage = () => {
  return (
    <>
      <AuthenticatedTemplate>
        <div className="h-[var(--app-height)] overflow-hidden">
          <Box className="flex h-full">
            <AdminMainLayout />

            <Box component="main" className="flex-1 bg-white px-6 py-4 overflow-auto">
              <DrawerHeader />
              <div
                style={{
                  borderRadius: 8,
                  padding: 20,
                  minHeight: "calc(100vh - 124px)",
                  boxSizing: "border-box",
                  boxShadow: "0 2px 12px rgba(0,0,0,0.04)",
                }}
                className="bg-[#bb1ccc]/5"
              >
                <AIDashboardWorkbench />
              </div>
            </Box>
          </Box>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
};

export default AIDashboardBuilderPage;